/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: `linear-gradient(135deg, ${theme.colors?.blue5 || '#1C35BC'} 0%, ${
      theme.colors?.lightBlue || '#00A8FF'
    } 100%)`,
    zIndex: 9999,
  },
  containerVisible: {
    animation: '$fadeInLoader 400ms ease-out forwards',
  },
  containerHiding: {
    animation: '$fadeOutLoader 300ms ease-out forwards',
    pointerEvents: 'none',
  },
  fadeOut: {
    opacity: 0,
    pointerEvents: 'none',
  },
  brandSection: {
    textAlign: 'center',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'opacity 200ms ease-out',
  },
  contentHiding: {
    opacity: 0,
  },
  logo: {
    width: 120,
    height: 120,
    marginLeft: 32,
    willChange: 'opacity',
    transform: 'translateZ(0)',
    backfaceVisibility: 'hidden',
  },
  part1: {
    fill: 'white',
    opacity: 0.7,
    animation: '$fadeIn 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    animationDelay: '0s',
    willChange: 'opacity',
  },
  part2: {
    fill: 'white',
    opacity: 0.7,
    animation: '$fadeIn 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    animationDelay: '0.4s',
    willChange: 'opacity',
  },
  mainTitle: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 8,
    letterSpacing: '0.5px',
    color: 'white',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    transform: 'scaleX(1.15)',
  },
  subtitle: {
    fontSize: 14,
    opacity: 0.8,
    marginBottom: 40,
    color: 'white',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  spinner: {
    width: 24,
    height: 24,
    border: '2px solid rgba(255, 255, 255, 0.3)',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: '$spin 1s linear infinite',
  },
  '@keyframes fadeInLoader': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  '@keyframes fadeOutLoader': {
    '0%': { opacity: 1 },
    '100%': { opacity: 0 },
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0.3 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0.3 },
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
}));

const PageLoader = ({ isHiding = false }) => {
  const classes = useStyles();

  const containerClasses = [
    classes.container,
    isHiding ? classes.containerHiding : classes.containerVisible,
  ].join(' ');

  const contentClasses = [classes.brandSection, isHiding ? classes.contentHiding : ''].join(' ');

  return (
    <div className={containerClasses}>
      <div className={contentClasses}>
        <svg className={classes.logo} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path
            className={classes.part1}
            d="M30.87,49.74A18.87,18.87,0,1,1,49.74,30.87c0,.34,0,.66-.05,1L52,34.14l9.2-9.24a30.85,30.85,0,1,0-19.71,35L31.33,49.72Z"
          />
          <polygon
            className={classes.part2}
            points="81.47,22.8 76.34,17.66 61.71,32.35 50.96,43.14 47.54,39.7 38.54,30.67 34.42,34.81 29.44,39.81 30.43,40.81 37.95,48.36 46.85,57.3 50.96,61.42 81.46,30.8 85.45,26.79 81.47,22.8"
          />
        </svg>
        <div className={classes.mainTitle}>QHSLab</div>
        <div className={classes.subtitle}>Quality Health System</div>
        <div className={classes.spinner}></div>
      </div>
    </div>
  );
};

PageLoader.propTypes = {
  fullHeight: PropTypes.bool,
  isHiding: PropTypes.bool,
};

export default PageLoader;
